import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import localize from './localize';

class Lightbox {
  constructor() {
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.js-text-and-image',
      children: '.js-image-lightbox',
      zoomTitle: localize('lightbox.zoom'),
      closeTitle: localize('lightbox.close'),
      arrowPrevTitle: localize('lightbox.previous'),
      arrowNextTitle: localize('lightbox.next'),
      pswpModule: () => PhotoSwipe
    });
    lightbox.init();

    const gallery = new PhotoSwipeLightbox({
      gallery: '.gallery',
      children: 'a',
      zoomTitle: localize('lightbox.zoom'),
      closeTitle: localize('lightbox.close'),
      arrowPrevTitle: localize('lightbox.previous'),
      arrowNextTitle: localize('lightbox.next'),
      pswpModule: () => PhotoSwipe
    });
    gallery.init();
  }
}

export default new Lightbox();
